import {
  Typography,
  Box,
  Button,
  IconButton,
  Avatar,
  useMediaQuery,
  Tab,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Modal,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TablePagination,
  Select,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useRef, useState } from "react";
import "./edit_profile.css";
import { useNavigate } from "react-router-dom";
import TextInput from "../../../components/TextInput/TextInput";
import { useForm } from "react-hook-form";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadIcon from "@mui/icons-material/Upload";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import LandLinePhoneFormatter from "../../../components/PhoneFormatter/LandLinePhoneFormatter";
import getEventController from "../Controller/getEvent_controller";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import axios from "axios";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "./cropImage"; // Utility for extracting cropped image
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import dayjs from "dayjs";

function AvatarButton() {
  //   return (
  //     <div style={{ position: "relative", display: "inline-block" }}>
  //       <IconButton onClick={() => console.log("hi")}>
  //         <img
  //           src={userData.profile_image}
  //           className="ep-profile-icon"
  //           alt="Profile"
  //         />
  //       </IconButton>
  //       <CreateOutlinedIcon
  //         className="profile-edit-icon"
  //         sx={{
  //           position: "absolute",
  //           bottom: 10, // Adjust this value to move vertically
  //           right: 10, // Adjust this value to move horizontally
  //           fontSize: "30px", // Adjust icon size if necessary
  //           border: "1px solid white",
  //           borderRadius: "50%",
  //           padding: "2px",
  //           backgroundColor: "#d33333",
  //           color: "white",
  //         }}
  //       />
  //     </div>
  //   );
}

const EditProfile = () => {
  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
    setError,
    getValues,
    clearErrors,
    setFocus,
  } = useForm({
    defaultValues: {
      nameOfCompany: "",
      registeredAddress: "",
      companyNumber: "",
      dateOfIncorporation: "",
      correspondenceAddress: "",
      nameOfBuilding: "",
      website: "",
      companyTelephoneNo: "",
      companyFax: "",
      companyEmail: "",
      grossBuiltUpArea: "",
      nettLettableArea: "",
      appointedRepresentativeName: "",
      appointedRepresentativeNRIC: "",
      appointedRepresentativeDOB: "",
      appointedRepresentativePOB: "",
      appointedRepresentativeRace: "",
      appointedRepresentativeSex: "",
      appointedRepresentativeNationality: "",
      appointedRepresentativeMaritalStatus: "",
      appointedRepresentativeOfficeTelNo: "",
      appointedRepresentativeFax: "",
      appointedRepresentativeHPNo: "",
      appointedRepresentativeEmail: "",
      appointedRepresentativeDesignation: "",
      appointedRepresentativeNatureOfWork: "",
      appointedRepresentativeNoOfYearsWithCompany: "",
      appointedRepresentativeAcademicQualification: "",
      alternateRepresentativeName: "",
      alternateRepresentativeNRIC: "",
      alternateRepresentativeDOB: "",
      alternateRepresentativePOB: "",
      alternateRepresentativeRace: "",
      alternateRepresentativeSex: "",
      alternateRepresentativeNationality: "",
      alternateRepresentativeMaritalStatus: "",
      alternateRepresentativeOfficeTelNo: "",
      alternateRepresentativeFax: "",
      alternateRepresentativeHPNo: "",
      alternateRepresentativeEmail: "",
      alternateRepresentativeDesignation: "",
      alternateRepresentativeNatureOfWork: "",
      alternateRepresentativeNoOfYearsWithCompany: "",
    },
  });

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const navigate = useNavigate();
  const isLargeScreen = useMediaQuery("(min-width:640px)");
  const memberId = localStorage.getItem("memberId");
  const memberType = localStorage.getItem("member_type");
  const email = localStorage.getItem("email");
  const userId = localStorage.getItem("userId");

  const required = () => (
    <span style={{ color: "red", marginLeft: "5px", fontSize: "17px" }}>*</span>
  );

  const [shouldRefetchData, setShouldRefetchData] = useState(false);

  //get Member Info by Email and MemberId
  useEffect(() => {
    getEventController
      .getMemberInfo(memberId, email)
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure

        // Set eventData directly from the response object
        if (response) {
          setMemberInfo({
            membername: response.name,
            email: response,
            email,
            memberId: response,
            memberId,
            address: response.address,
            place_of_birth: response.place_of_birth,
            phone: response.handphone_no,
            race: response.race,
            gender: response.gender,
            nationality: response.nationality,
            marital_status: response.marital_status,
            academic_qualification: response.academic_qualification,
            office_email: response.office_email,
            office_tel: response.office_tel_no,
            fax_no: response.fax,
            nature_of_work: response.nature_of_work,
            years_with_company: response.years_with_company,
            company_name: response.company_name,
            membership_type: response.label,
            date_of_incorporation: response.date_of_incorporation,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, [memberId, shouldRefetchData]);

  //get Membership Info by MemberId
  useEffect(() => {
    getEventController
      .getMembershipInfo(memberId)
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure

        // Format the expiry_date to "December 31, 2025"
        const formattedExpiryDate = response?.membership_expiry_date
          ? new Date(response.membership_expiry_date).toLocaleDateString(
              "en-US",
              {
                year: "numeric",
                month: "long",
                day: "numeric",
              }
            )
          : "NA";

        // Set eventData directly from the response object
        if (response) {
          setMembershipInfo({
            memberId: response,
            memberId,
            company_name: response.company_name,
            membership_type: response.label,
            date_of_incorporation: response.date_of_incorporation || "NA",
            expiry_date: formattedExpiryDate,
            company_email: response.email,
            company_tel_no: response.telephone_no,
            company_registered_address: response.registered_address,
            company_correspondence_address: response.correspondence_address,
            gross_build_up_area: response.gross_build_up_area,
            nett_lettable_area: response.nett_lettable_area,
            website: response.website,
            e_invoicing_pin: response.e_invoice_pin,
            datetime_updated: response.datetime_updated,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, [memberId, shouldRefetchData]);

  //Handle Update Member Info
  const [MemberInfo, setMemberInfo] = useState({
    memberId: memberId, // get memberId from local storage
    membername: "",
    email: email,
    address: "",
    place_of_birth: "",
    phone: "",
    race: "",
    gender: "",
    nationality: "",
    marital_status: "",
    academic_qualification: "",
    office_email: "",
    office_tel: "",
    fax: "",
    nature_of_work: "",
    years_with_company: "",
    companyEmail: "",
  });

  const handleMemberInputChange = (e) => {
    const { name, value } = e.target;
    setMemberInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    // console.log(MemberInfo);
    const response = await getEventController.updateProfile({
      MemberInfo,
    });

    if (response.success) {
      alert("Profile updated successfully!");
    } else {
      alert(response.message || "Profile update failed.");
    }
  };

  //Handle Update Membership Info
  const [MembershipInfo, setMembershipInfo] = useState({});

  const handleMembershipInputChange = (e) => {
    const { name, value } = e.target;
    setMembershipInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateMembershipInfo = async (e) => {
    e.preventDefault();
    console.log(MembershipInfo);
    const response = await getEventController.updateMembershipInfo({
      MembershipInfo,
    });

    if (response.success) {
      alert("Membership Info updated successfully!");
      setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
    } else {
      alert(response.message || "Membership Info update failed.");
    }
  };

  //Handle Fetch Member List by MemberID
  const [memberList, setMemberList] = useState([]); // State to store member data

  //get Member by MemberID
  useEffect(() => {
    if (!memberId) {
      console.error("Member ID is missing");
      return;
    }

    getEventController
      .getMembersbyMemberId(memberId)
      .then((response) => {
        if (Array.isArray(response)) {
          console.log("API Response:", response); // Log the API response to check structure

          // Map response to the desired structure
          const memberData = response.map((item) => ({
            userID: item.userID,
            membername: item.name,
            email: item.email,
            memberId: item.memberId,
            address: item.address,
            place_of_birth: item.place_of_birth,
            phone: item.handphone_no,
            race: item.race,
            gender: item.gender,
            nationality: item.nationality,
            marital_status: item.marital_status,
            academic_qualification: item.academic_qualification,
            profile_image: item.profile_image,
            office_email: item.office_email,
            office_tel: item.office_tel_no,
            fax_no: item.fax,
            nature_of_work: item.nature_of_work,
            years_with_company: item.years_with_company,
            membership_type: item.type,
            datetime_updated: item.datetime_updated,
          }));

          setMemberList(memberData); // Update state with the member data
        } else {
          console.error("Unexpected API response format:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, [memberId, shouldRefetchData]);

  const getMembershipType = (membershipType) => {
    if (membershipType === 0) return "Appointed";
    if (membershipType === 1) return "Alternate";
    if (membershipType === 2) return "Others";
  };

  //Edit User Profile
  const [isModalOpen, setModalOpen] = useState(false); // Modal state
  const [selectedUserId, setSelectedUserId] = useState(null); // Selected user ID
  const [userData, setUserData] = useState({}); // User data from the database
  const [selectedFile, setSelectedFile] = useState(null);

  const handleUserInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  // Function to open modal and set user ID
  const handleOpenModal = (userID) => {
    setSelectedUserId(userID); // Set user ID
    setModalOpen(true); // Open modal
    console.log(userID);

    //get Membership Info by MemberId
    getEventController
      .getUserInfo(userID)
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure

        // Set eventData directly from the response object
        if (response) {
          setUserData({
            userId: response.userID,
            salutation: response.salutation,
            name: response.name,
            nric: response.nric,
            email: response.email,
            address: response.address,
            phone_number: response.handphone_no,
            gender: response.gender,
            academic_qualification: response.academic_qualification,
            profile_image: response.profile_image,
            alternate_email: response.alternate_email,
            office_tel_no: response.office_tel_no,
            nature_of_work: response.nature_of_work,
            years_with_company: response.years_with_company,
            designation: response.designation,
            datetime_updated: response.datetime_updated,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
      });
  };

  // Function to close modal
  const handleCloseModal = () => {
    setModalOpen(false); // Close modal
    setUserData({}); // Clear user data
  };

  const handleDeleteAccount = (userID) => {
    console.log(userID);
  };

  // Handle file selection
  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setSelectedFile(file);

  //     // Show a preview of the selected file
  //     const reader = new FileReader();
  //     reader.onload = () =>
  //       setUserData((prev) => ({ ...prev, profile_image: reader.result }));
  //     reader.readAsDataURL(file);
  //   }
  // };

  // Trigger file input
  const handleUploadClick = () => {
    document.getElementById("file-input").click();
  };

  const handleUpdateUserProfile = async (e) => {
    e.preventDefault();

    // console.log(userData);

    const response = await getEventController.updateProfile({
      userData,
      croppedImage,
    });

    if (response.success) {
      alert("Profile updated successfully!");
      setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
      handleReupload();
      handleCloseModal();
    } else {
      alert(response.message || "Profile update failed.");
    }
  };

  //Tab 3: Membership Renewal
  const columns = [
    { id: "number", label: "No.", minWidth: 100 },
    { id: "terms", label: "Terms", minWidth: 300 },
    {
      id: "status",
      label: "Status",
      minWidth: 100,
      align: "center",
    },
    {
      id: "details",
      label: "Details",
      minWidth: 100,
      align: "center",
    },
  ];

  function createData(number, terms, status, details) {
    return { number, terms, status, details };
  }

  const [page, setPage] = React.useState(0);
  const [rows, setRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [open, setOpen] = useState(false); // State for modal
  const [selectedDetails, setSelectedDetails] = useState(null); // State for modal content
  const [selectedPaymentData, setSelectedPaymentData] = useState({
    invoice_no: "",
    contact_name: "",
    contact_phone_no: "",
    contact_email: "",
    amounts: "",
    status: "",
    issued_date: "",
    paid_date: "",
  }); // User data from the database

  const handleOpen = (paymentID) => {
    setSelectedDetails(paymentID); // Set the details of the clicked row
    setOpen(true);
    console.log(paymentID);

    //get Payment Info by paymentId
    getEventController
      .getPaymentInfo(paymentID)
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure

        // Set eventData directly from the response object
        if (response) {
          const statusMap = {
            0: "Pending",
            1: "Renewed",
            2: "Unpaid",
          };

          // Process amounts
          const formattedAmounts = (() => {
            if (response.amounts.includes(",")) {
              // Split the amounts by comma, parse to numbers, sum up, and format to two decimals
              const total = response.amounts
                .split(",")
                .map((value) => parseFloat(value.trim()))
                .reduce((acc, curr) => acc + curr, 0);
              return total.toFixed(2); // Format to two decimal places
            }
            return parseFloat(response.amounts).toFixed(2); // Format single value
          })();

          setSelectedPaymentData({
            invoice_no: response.invoice_no,
            contact_name: response.contact_name,
            contact_phone_no: response.contact_hp,
            contact_email: response.contact_email,
            amounts: formattedAmounts,
            status: statusMap[response.status] || "Unknown", // Default to "Unknown"
            issued_date: response.datetime_created,
            paid_date: response.datetime_updated || "NA",
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching payment details:", error);
      });
  };

  const handleClose = () => setOpen(false);

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    height: 400,
    bgcolor: "background.paper",
    borderRadius: "25px",
    boxShadow: 24,
    p: 4,
  };

  useEffect(() => {
    getEventController
      .getMembershipRenewalHistory(memberId)
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure

        if (response) {
          const formatDate = (dateString) => {
            const [year, month, day] = dateString.split("-");
            return `${day}/${month}/${year}`;
          };

          const statusMapping = {
            0: "Pending",
            1: "Renewed",
            2: "Unpaid",
          };

          // Map the API response to rows
          const fetchedRows = response.map((item, index) => ({
            number: index + 1, // Sequential number
            terms: `${formatDate(item.min_term)} - ${formatDate(
              item.max_term
            )}`,
            status: statusMapping[item.status] || "Unknown", // Default to "Unknown"
            details: item.paymentID || "No additional details", // Store details
          }));
          setRows(fetchedRows);
        }
      })
      .catch((error) => {
        console.error("Error fetching membership info:", error);
      });
  }, [memberId]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  //Renew Membership
  const [RenewMembershipData, setRenewMembershipData] = useState({}); // User data from the database

  const [RenewMembershipModalOpen, setRenewMembershipModalOpen] =
    useState(false); // State for modal
  const handleCloseRenewMembershipModal = () =>
    setRenewMembershipModalOpen(false);

  const RenewMembershipModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 520,
    height: 520,
    bgcolor: "background.paper",
    borderRadius: "25px",
    boxShadow: 24,
    p: 4,
  };

  const handleOpenRenewMembershipModal = () => {
    setRenewMembershipModalOpen(true);
    console.log(memberId);

    // Get Renew Membership Info by MemberId
    getEventController
      .getRenewMembershipInfo(memberId)
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure

        if (response) {
          // Helper function to reformat date
          const formatDate = (dateString) => {
            const [year, month, day] = dateString.split("-");
            return `${day}/${month}/${year}`;
          };

          // Helper function to add a year to a date
          const incrementYear = (dateString) => {
            const [year, month, day] = dateString.split("-");
            const newYear = parseInt(year, 10) + 1;
            return `${newYear}-${month}-${day}`;
          };

          // Process terms
          const newMinTerm = formatDate(response.max_term); // Reformat max_term as new_min_term
          const rawNewMaxTerm = incrementYear(response.max_term); // Increment max_term by 1 year
          const newMaxTerm = formatDate(rawNewMaxTerm); // Reformat the incremented date

          // Process amounts
          const formattedAmounts = parseFloat(response.amount).toFixed(2);

          setRenewMembershipData({
            memberID: memberId,
            company_name: response.company_name,
            min_term: newMinTerm, // The previous max_term
            max_term: newMaxTerm, // Incremented and formatted max_term
            amount: formattedAmounts,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching membership renewal details:", error);
      });
  };

  //Create Account
  const [memberAllotment, setMemberAllotment] = useState({}); // User data from the database
  const [NewAccountData, setNewAccountData] = useState(false); // User data from the database
  const [CreateAccData, setCreateAccData] = useState({
    memberID: memberId,
    userType: "1", // Default value
    name: "",
    nric_number: "",
    email: "",
  });

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let formattedValue = value;

    // Apply special formatting for the NRIC field
    if (name == "nric_number") {
      const numbersOnly = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters

      if (numbersOnly.length > 6) {
        formattedValue = `${numbersOnly.slice(0, 6)}-${numbersOnly.slice(6)}`;
      }
      if (numbersOnly.length > 8) {
        formattedValue = `${numbersOnly.slice(0, 6)}-${numbersOnly.slice(
          6,
          8
        )}-${numbersOnly.slice(8)}`;
      }
    }

    // Update the state
    setCreateAccData((prev) => ({ ...prev, [name]: formattedValue }));
  };

  const handleOpenCreateAccountModal = () => {
    setNewAccountData(true);
    console.log(memberId);
    let alternateAllotment = 1;
    let othersAllotment = 1;

    //get Membership Info by MemberId
    getEventController
      .getMemberAllotment(memberId)
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure

        // Set eventData directly from the response object
        if (response) {
          const alternateUsed = Number(response.alternate);
          const othersUsed = Number(response.others);

          setMemberAllotment({
            membership_registrationID: response.membership_registrationID,
            company_name: response.company_name,
            alternate: alternateUsed,
            appointed: response.appointed,
            others: response.others,
            accounts_allotment: response.accounts_allotment,
            alternate_left: alternateAllotment - alternateUsed,
            others_left: othersAllotment - othersUsed,
          });

          // console.log("Alternate Allotment:", alternateAllotment);
          // console.log("Alternate Used:", response.alternate);
          // console.log("Alternate Left:", alternateAllotment - alternateUsed);
        }
      })
      .catch((error) => {
        console.error("Error fetching details:", error);
      });
  };

  // Function to close modal
  const handleCloseCreateAccountModal = () => {
    setNewAccountData(false); // Close modal
    setCreateAccData({}); // Clear user data
  };

  const handleCreateNewAccount = async (e) => {
    e.preventDefault();

    const { userType } = CreateAccData; // Get the selected user type
    const allotmentLeft =
      userType === "1"
        ? memberAllotment.alternate_left
        : memberAllotment.others_left; // Determine the relevant allotment value

    if (allotmentLeft <= 0) {
      alert("Cannot create an account: Allotment is full.");
      return; // Stop the function if no allotment left
    }

    const payload = {
      ...CreateAccData,
      companyName: memberAllotment.company_name,
      membership_registrationID: memberAllotment.membership_registrationID,
    };

    console.log(payload);
    console.log(CreateAccData);
    console.log(memberAllotment.company_name);
    console.log(memberAllotment.membership_registrationID);

    const response = await getEventController.createMemberUser({
      payload,
    });

    if (response.success) {
      alert("User Created Successful!");
      handleCloseModal();
    } else {
      alert(response.message || "User Create failed.");
    }
  };

  const [image, setImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedImage, setCroppedImage] = useState(null);
  const [showCropper, setShowCropper] = useState(true); // Controls cropper visibility

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setImage(reader.result);
      reader.readAsDataURL(file);
      setShowCropper(true); // Show cropper when a new image is uploaded
    }
  };

  const handleReupload = () => {
    setImage(null);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedImage(null);
  };

  const onCropComplete = async (croppedArea, croppedAreaPixels) => {
    const croppedImage = await getCroppedImg(image, croppedAreaPixels);
    setCroppedImage(croppedImage);
  };

  const handleSave = () => {
    if (croppedImage) {
      console.log("Cropped image saved:", croppedImage);
    }
  };

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="edit-profile">
          <Box sx={{ display: "flex" }}>
            <Box component="main" sx={{ flexGrow: 1, p: 3, height: "auto" }}>
              {/* <DrawerHeader /> */}
              {/* {showAlertSuccess && (
              <Alert severity="success" sx={{ mb: 2 }}>
                {alertSuccessMsg}
              </Alert>
            )} */}

              <form>
                <Box sx={{ flexGrow: 1 }}>
                  <div className="sm-personal-details-title">
                    <span>Personal Details</span>
                  </div>
                  <Grid container spacing={2}>
                    <Grid
                      size={{ xs: 12, md: 12 }}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <AvatarButton />
                    </Grid>
                    {/* Name */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Name</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Email */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Email</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Address */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Address</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Place of Birth */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Place of Birth</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Phone Number */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Phone Number</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Race */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Race</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Gender */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Gender</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Nationality */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Nationality</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Marital Status */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Marital Status</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Academic Qualification */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Academic Qualification</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                  </Grid>

                  <div className="office-details-title">
                    <span>Office/Company Details</span>
                  </div>

                  <Grid container spacing={2}>
                    {/* Office Email */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Office Email</label>
                      <TextInput
                        type="email"
                        name="companyEmail"
                        {...register("companyEmail", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.companyEmail ? errors.companyEmail.message : ""
                        }
                        onEmailCheck={(error) => {
                          if (error?.type === "invalidFormat") {
                            setError("companyEmail", {
                              type: "manual",
                              message: error.message,
                            });
                          } else if (error?.type === "duplicate") {
                            setError("companyEmail", {
                              type: "manual",
                              message: error.message,
                            });
                          } else if (error?.type === "duplicateInForm") {
                            setError("companyEmail", {
                              type: "manual",
                              message: error.message,
                            });
                          } else {
                            clearErrors("companyEmail");
                          }
                        }}
                        control={control}
                        getValues={getValues}
                      />
                    </Grid>
                    {/* Office Tel No */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Office Tel No.</label>
                      <LandLinePhoneFormatter
                        name="companyTelephoneNo"
                        onErrorCheck={
                          errors.companyTelephoneNo
                            ? errors.companyTelephoneNo.message
                            : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Fax No */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Fax No.</label>
                      <TextInput
                        type="text"
                        {...register("companyFax", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.companyFax ? errors.companyFax.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Nature Of Work */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Nature of Work</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                    {/* Years with Company */}
                    <Grid size={{ xs: 12, md: 12 }}>
                      <label>Years with Company</label>
                      <TextInput
                        type="text"
                        {...register("eventName", {
                          required: "This field is required",
                        })}
                        onErrorCheck={
                          errors.eventName ? errors.eventName.message : ""
                        }
                        control={control}
                      />
                    </Grid>
                  </Grid>

                  <Box textAlign="center">
                    <Button
                      sx={{
                        borderRadius: "20px",
                        mt: 4,
                        mb: 4,
                        width: "100%",
                        height: "48px",
                        backgroundColor: "#d33333",
                        textTransform: "none",
                      }}
                      variant="contained"
                      type="submit"
                    >
                      <Typography variant="h6">Update Profile</Typography>
                    </Button>
                  </Box>
                </Box>
              </form>
            </Box>
          </Box>
        </div>
      ) : (
        <div className="edit-profile">
          {/* Back Button */}
          <div>
            <ArrowBackIosIcon
              className="logo"
              onClick={() => navigate(-1)}
              label="BACK"
            />
          </div>
          {/* Tab List */}
          <Box sx={{ width: "100%", typography: "body1", padding: "10px" }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  sx={{
                    ".MuiTab-root": {
                      minHeight: "50px", // Decrease height
                      borderRadius: "8px 8px 0 0", // Rounded corners on top-left and top-right
                      fontWeight: "bold", // Bold font
                      textTransform: "none", // Disable uppercase text
                      "&:hover": {
                        textDecoration: "none", // Remove underline on hover
                      },
                      transition: "all 0.3s ease-in-out", // Smooth transition for all properties
                    },
                    ".Mui-selected": {
                      backgroundColor: "#d33333", // Example active tab background color
                      color: "white !important", // Example active tab text color
                      borderBottom: "none", // Remove underline when selected
                    },
                    ".MuiTabs-indicator": {
                      display: "none", // Remove the default blue underline
                    },
                  }}
                >
                  <Tab
                    icon={<CardMembershipOutlinedIcon />}
                    iconPosition="start"
                    label="Membership Info"
                    value="1"
                  />
                  <Tab
                    icon={<GroupAddIcon />}
                    iconPosition="start"
                    label="Manage Accounts"
                    value="2"
                  />
                  {/* <Tab
                    icon={<AutorenewIcon />}
                    iconPosition="start"
                    label="Membership Renewal"
                    value="3"
                  /> */}
                </TabList>
              </Box>
              {/* Membership Info */}
              <TabPanel value="1">
                <form onSubmit={handleUpdateMembershipInfo}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                      {/* Membership No. */}
                      <Grid size={{ xs: 6, md: 6 }}>
                        <label className="ep-label form-label">
                          Membership No.
                        </label>
                        <input
                          name="membershipNumber"
                          className="ep-input form-control"
                          type="text"
                          placeholder="Membership No."
                          value={MembershipInfo.memberId}
                          readOnly
                          disabled
                        />
                      </Grid>
                      {/* Company Name */}
                      <Grid size={{ xs: 6, md: 6 }}>
                        <label className="ep-label form-label">
                          Company Name
                        </label>
                        <input
                          name="companyName"
                          className="ep-input form-control"
                          placeholder="Company Name"
                          value={MembershipInfo.company_name}
                          readOnly
                          disabled
                        />
                      </Grid>
                      {/* Membership Type */}
                      <Grid size={{ xs: 6, md: 6 }}>
                        <label className="ep-label form-label">
                          Membership Type
                        </label>
                        <input
                          name="membershipType"
                          className="ep-input form-control"
                          type="text"
                          placeholder="Membership Type"
                          value={MembershipInfo.membership_type}
                          readOnly
                          disabled
                        />
                      </Grid>
                      {/* Membership Since (Date of Incoporation) */}
                      {/* <Grid size={{ xs: 6, md: 6 }}>
                        <label className="ep-label form-label">
                          Membership Since
                        </label>
                        <input
                          name="dateofIncoporation"
                          className="ep-input form-control"
                          type="text"
                          placeholder="Date of Incoporation"
                          value={MembershipInfo.date_of_incorporation}
                          readOnly
                          disabled
                        />
                      </Grid> */}
                      {/* Expiry Date */}
                      <Grid size={{ xs: 6, md: 6 }}>
                        <label className="ep-label form-label">
                          Expiry Date
                        </label>
                        <input
                          name="expiryDate"
                          className="ep-input form-control"
                          placeholder="Expiry Date"
                          value={MembershipInfo.expiry_date}
                          readOnly
                          disabled
                        />
                      </Grid>
                      {/* <Grid size={{ xs: 6, md: 6 }} /> */}
                      {/* Company Email */}
                      <Grid size={{ xs: 6, md: 6 }}>
                        <label className="ep-label form-label">
                          Email{required()}
                        </label>
                        <input
                          name="company_email"
                          className="ep-input2 form-control"
                          type="email"
                          placeholder="Company Email"
                          value={MembershipInfo.company_email}
                          onChange={handleMembershipInputChange}
                          required
                        />
                      </Grid>
                      {/* Company Telephone Number */}
                      <Grid size={{ xs: 6, md: 6 }}>
                        <label className="ep-label form-label">
                          Telephone No.{required()}
                        </label>
                        <input
                          name="company_tel_no"
                          className="ep-input2 form-control"
                          type="text"
                          placeholder="Company Telephone Number"
                          value={MembershipInfo.company_tel_no}
                          onChange={handleMembershipInputChange}
                          required
                        />
                      </Grid>
                      {/* Company Registered Address */}
                      <Grid size={{ xs: 12, md: 12 }}>
                        <label className="ep-label form-label">
                          Registered Address{required()}
                        </label>
                        <input
                          name="company_registered_address"
                          className="ep-input2 form-control"
                          type="text"
                          placeholder="Company Registered Address"
                          value={MembershipInfo.company_registered_address}
                          onChange={handleMembershipInputChange}
                          required
                        />
                      </Grid>
                      {/* Company Correspondence Address */}
                      <Grid size={{ xs: 12, md: 12 }}>
                        <label className="ep-label form-label">
                          Correspondence Address{required()}
                        </label>
                        <input
                          name="company_correspondence_address"
                          className="ep-input2 form-control"
                          type="text"
                          placeholder="Company Correspondence Address"
                          value={MembershipInfo.company_correspondence_address}
                          onChange={handleMembershipInputChange}
                          required
                        />
                      </Grid>
                      {/* Gross Build Up Area (ft) */}
                      <Grid size={{ xs: 6, md: 6 }}>
                        <label className="ep-label form-label">
                          Gross Build Up Area(feet²)
                        </label>
                        <input
                          name="gross_build_up_area"
                          className="ep-input2 form-control"
                          type="number"
                          placeholder="Gross Build Up Area(feet²)"
                          value={MembershipInfo.gross_build_up_area}
                          min="0"
                          onChange={handleMembershipInputChange}
                        />
                      </Grid>
                      {/* Nett Lettable Area (ft) */}
                      <Grid size={{ xs: 6, md: 6 }}>
                        <label className="ep-label form-label">
                          Net Lettable Area(feet²)
                        </label>
                        <input
                          name="nett_lettable_area"
                          className="ep-input2 form-control"
                          type="number"
                          min="0"
                          placeholder="Net Lettable Area(feet²)"
                          value={MembershipInfo.nett_lettable_area}
                          onChange={handleMembershipInputChange}
                        />
                      </Grid>
                      {/* Website Address */}
                      <Grid size={{ xs: 6, md: 6 }}>
                        <label className="ep-label form-label">
                          Website Address
                        </label>
                        <input
                          name="website"
                          className="ep-input2 form-control"
                          type="text"
                          placeholder="Website Address"
                          value={MembershipInfo.website}
                          onChange={handleMembershipInputChange}
                        />
                      </Grid>
                      {/* E-Invoicing Pin No. */}
                      <Grid size={{ xs: 6, md: 6 }}>
                        <label className="ep-label form-label">
                          E-Invoicing Pin No.
                        </label>
                        <input
                          name="e_invoicing_pin"
                          className="ep-input2 form-control"
                          type="text"
                          placeholder="E-Invoicing Pin Number"
                          value={MembershipInfo.e_invoicing_pin}
                          onChange={handleMembershipInputChange}
                        />
                      </Grid>
                    </Grid>

                    <Box textAlign="center">
                      <Button
                        sx={{
                          borderRadius: "20px",
                          mt: 4,
                          mb: 4,
                          width: "100%",
                          height: "48px",
                          backgroundColor: "#d33333",
                          textTransform: "none",
                        }}
                        variant="contained"
                        type="submit"
                      >
                        <Typography variant="h6">Save</Typography>
                      </Button>
                    </Box>
                    <Grid
                      size={{ xs: 12, md: 12 }}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <InfoIcon fontSize="small" sx={{ marginRight: "5px" }} />
                      <label>
                        Last updated on{" "}
                        {dayjs(MembershipInfo.datetime_updated).format(
                          "DD-MM-YYYY HH:mm:ss"
                        )}
                      </label>
                    </Grid>
                  </Box>
                </form>
              </TabPanel>
              {/* Manage Account */}
              <TabPanel value="2">
                {(memberType === "MTYPE-000001" ||
                  memberType === "MTYPE-000004") && (
                  <div className="create-account-button">
                    <Button
                      sx={{
                        borderRadius: "10px",
                        height: "40px",
                        backgroundColor: "#d33333",
                        textTransform: "none",
                        color: "white",
                      }}
                      onClick={() => handleOpenCreateAccountModal()} // Pass the details to the modal
                    >
                      <Typography
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        Create Account
                      </Typography>
                    </Button>
                  </div>
                )}
                <div className="mb-2">
                  <MenuList sx={{ padding: "12px" }}>
                    {memberList.map((member, index) => (
                      <div key={index}>
                        {/* Title for each MenuItem */}
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            marginBottom: "5px",
                            color: "#555",
                          }}
                        >
                          {getMembershipType(member.membership_type)}
                        </Typography>
                        {/* MenuItem */}
                        <MenuItem
                          disableRipple
                          className="mt-2"
                          sx={{
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            backgroundColor: "#e8e8e8",
                            padding: "10px",
                            marginBottom: "10px",
                            cursor: "default",
                            "&:hover": {
                              backgroundColor: "#e8e8e8",
                            },
                            marginBottom: "20px",
                          }}
                        >
                          <ListItemIcon>
                            {member.profile_image &&
                            member.profile_image.trim() !== "" ? (
                              <img
                                src={member.profile_image}
                                className="ep-profile-icon"
                                alt="Profile"
                              />
                            ) : (
                              <AccountCircleIcon
                                className="ep-profile-icon"
                                sx={{ fontSize: 40, color: "gray" }}
                              />
                            )}
                          </ListItemIcon>
                          <ListItemText
                            sx={{
                              marginLeft: "20px",
                            }}
                            primaryTypographyProps={{ fontSize: "18px" }}
                            primary={member.membername}
                            secondary={member.email}
                          />
                          <Button
                            className="ep-icon-button"
                            title="Edit"
                            disableRipple
                            value={member.userID}
                            onClick={() => handleOpenModal(member.userID)} // Open modal with userID
                          >
                            <EditNoteIcon className="ep-icon-button" />
                          </Button>
                          {userId !== member.userID && (
                            <Button
                              className="ep-icon-button"
                              title="Delete"
                              disableRipple
                              onClick={() => handleDeleteAccount(member.userID)}
                            >
                              <DeleteIcon className="ep-icon-button" />
                            </Button>
                          )}
                        </MenuItem>
                      </div>
                    ))}
                  </MenuList>
                </div>
              </TabPanel>
              {/* Membership Renewal */}
              <TabPanel value="3">
                <div className="mr-label">
                  <span>Renewal History</span>
                  <Button
                    sx={{
                      borderRadius: "10px",
                      height: "40px",
                      backgroundColor: "#d33333",
                      textTransform: "none",
                      color: "white",
                    }}
                    onClick={() => handleOpenRenewMembershipModal()} // Pass the details to the modal
                  >
                    <Typography>Renew Membership</Typography>
                  </Button>
                </div>
                {/* filters */}
                {/* <div className="mr-label2">
                    <span>Filters</span>
                  </div> */}
                {/* <div className="col-md-12 row">
                    <div className="col-md-6">
                      <select className="form-select"></select>
                    </div>
                    <div className="col-md-6">
                      <select className="form-select"></select>
                    </div>
                  </div> */}
                {/* renewal history */}
                <div className="mt-4">
                  <Paper
                    sx={{ width: "100%", overflow: "hidden", boxShadow: 5 }}
                  >
                    <TableContainer sx={{ maxHeight: 440 }}>
                      <Table>
                        <TableHead
                          sx={{
                            backgroundColor: "lightgrey",
                          }}
                        >
                          <TableRow>
                            {columns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  minWidth: column.minWidth,
                                  fontSize: "15px",
                                  fontWeight: "bold",
                                  padding: "10px",
                                }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => {
                              return (
                                <TableRow
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={row.number}
                                >
                                  {columns.map((column) => {
                                    const value = row[column.id];
                                    return (
                                      <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{
                                          fontSize: "15px",
                                          padding: "10px",
                                        }}
                                      >
                                        {column.id === "details" ? (
                                          <IconButton
                                            color="primary"
                                            onClick={() => handleOpen(value)} // Pass the details to the modal
                                          >
                                            <InfoIcon />
                                          </IconButton>
                                        ) : (
                                          value
                                        )}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      component="div"
                      count={rows.length} // Total number of rows
                      rowsPerPage={rowsPerPage} // Fixed rows per page
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPageOptions={[]} // Hide rows-per-page dropdown
                      labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} of ${
                          count !== -1 ? count : `more than ${to}`
                        }`
                      }
                    />

                    <Modal
                      open={open}
                      onClose={handleClose}
                      closeAfterTransition
                      BackdropProps={{
                        onClick: (e) => e.stopPropagation(), // Prevent backdrop click
                      }}
                    >
                      <Box sx={{ ...modalStyle, position: "relative" }}>
                        {/* Close Button */}
                        <IconButton
                          onClick={handleClose}
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                          }}
                        >
                          <CloseIcon />
                        </IconButton>

                        {/* Modal Content */}
                        <Typography
                          sx={{
                            fontSize: "30px",
                            fontWeight: "bold",
                            color: "#b24743",
                            marginBottom: "10px",
                          }}
                        >
                          Payment Details
                        </Typography>
                        {selectedPaymentData ? (
                          <div className="selected_payment_details">
                            <div className="col-md-12 row">
                              <div className="col-md-6 payment_details_label">
                                <span>Invoice No.:</span>
                              </div>
                              <div className="col-md-6 payment_details_data">
                                <span>{selectedPaymentData.invoice_no}</span>
                              </div>
                            </div>
                            <div className="col-md-12 row">
                              <div className="col-md-6 payment_details_label">
                                <span>Issued To.:</span>
                              </div>
                              <div className="col-md-6 payment_details_data">
                                <span>{selectedPaymentData.contact_name}</span>
                              </div>
                            </div>
                            <div className="col-md-12 row">
                              <div className="col-md-6 payment_details_label">
                                <span>Contact Phone No.:</span>
                              </div>
                              <div className="col-md-6 payment_details_data">
                                <span>
                                  {selectedPaymentData.contact_phone_no}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-12 row">
                              <div className="col-md-6 payment_details_label">
                                <span>Contact Email:</span>
                              </div>
                              <div className="col-md-6 payment_details_data">
                                <span>{selectedPaymentData.contact_email}</span>
                              </div>
                            </div>
                            <div className="col-md-12 row">
                              <div className="col-md-6 payment_details_label">
                                <span>Payment Amount:</span>
                              </div>
                              <div className="col-md-6 payment_details_data">
                                <span>RM {selectedPaymentData.amounts}</span>
                              </div>
                            </div>
                            <div className="col-md-12 row">
                              <div className="col-md-6 payment_details_label">
                                <span>Status:</span>
                              </div>
                              <div className="col-md-6 payment_details_data">
                                <span>{selectedPaymentData.status}</span>
                              </div>
                            </div>
                            <div className="col-md-12 row">
                              <div className="col-md-6 payment_details_label">
                                <span>Issued On:</span>
                              </div>
                              <div className="col-md-6 payment_details_data">
                                <span>{selectedPaymentData.issued_date}</span>
                              </div>
                            </div>
                            <div className="col-md-12 row">
                              <div className="col-md-6 payment_details_label">
                                <span>Paid On:</span>
                              </div>
                              <div className="col-md-6 payment_details_data">
                                <span>{selectedPaymentData.paid_date}</span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <Typography>Loading...</Typography>
                        )}
                      </Box>
                    </Modal>
                  </Paper>
                </div>
                {/* <span className="mr-span-label">
                    Notice: Please renew your membership before January 31, 2026
                    to prevent your membership from being suspended.
                  </span> */}
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      )}

      {/* Modal Create Account */}
      <Modal
        open={NewAccountData}
        closeAfterTransition
        BackdropProps={{
          onClick: (e) => e.stopPropagation(), // Prevent backdrop click
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            height: 600,
            bgcolor: "background.paper",
            borderRadius: "25px",
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleCloseCreateAccountModal}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>

          <div className="personal-details-title">
            <span>New Account Details</span>
          </div>

          {/* Form fields populated with user data */}
          <form onSubmit={handleCreateNewAccount}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {/* User Type */}
                <Grid size={{ xs: 12, md: 12 }}>
                  <label className="ep-label form-label">User Type</label>
                  <select
                    name="userType"
                    className="ep-input2 form-select"
                    value={CreateAccData.userType}
                    onChange={handleInputChange}
                  >
                    <option value="1">
                      Alternate (Allotment Left:
                      {memberAllotment.alternate_left})
                    </option>
                    <option value="2">
                      Others (Allotment Left: {memberAllotment.others_left})
                    </option>
                  </select>
                </Grid>
                {/* Name */}
                <Grid size={{ xs: 12, md: 12 }}>
                  <label className="ep-label form-label">
                    Full Name (as per NRIC)
                  </label>
                  <input
                    name="name"
                    className="ep-input2 form-control"
                    type="text"
                    placeholder="eg. Ivan"
                    value={CreateAccData.name}
                    onChange={handleInputChange}
                  />
                </Grid>
                {/* NRIC */}
                <Grid size={{ xs: 12, md: 12 }}>
                  <label className="ep-label form-label">NRIC No.</label>
                  <input
                    name="nric_number"
                    className="ep-input2 form-control"
                    type="text"
                    placeholder="XXXXXX-13-XXXX"
                    value={CreateAccData.nric_number}
                    onChange={handleInputChange}
                    maxLength={14} // Ensures input does not exceed the format
                  />
                </Grid>
                {/* Email */}
                <Grid size={{ xs: 12, md: 12 }}>
                  <label className="ep-label form-label">Email</label>
                  <input
                    name="email"
                    className="ep-input2 form-control"
                    type="email"
                    placeholder="eg. example@gmail.com"
                    value={CreateAccData.email}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>

              <Box textAlign="center">
                <Button
                  sx={{
                    borderRadius: "20px",
                    mt: 4,
                    mb: 4,
                    width: "100%",
                    height: "48px",
                    backgroundColor: "#d33333",
                    textTransform: "none",
                  }}
                  variant="contained"
                  type="submit"
                >
                  <Typography variant="h6">Create and Notify</Typography>
                </Button>
              </Box>
            </Box>
          </form>
        </Box>
      </Modal>

      {/* Modal Renew Membership */}
      <Modal
        open={RenewMembershipModalOpen}
        closeAfterTransition
        BackdropProps={{
          onClick: (e) => e.stopPropagation(), // Prevent backdrop click
        }}
      >
        <Box sx={{ ...RenewMembershipModalStyle, position: "relative" }}>
          {/* Close Button */}
          <IconButton
            onClick={handleCloseRenewMembershipModal}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Modal Content */}
          <Typography
            sx={{
              fontSize: "30px",
              fontWeight: "bold",
              color: "#b24743",
              marginBottom: "10px",
            }}
          >
            Membership Renewal
          </Typography>
          {RenewMembershipData ? (
            <div className="renew_membership_modal">
              <div className="col-md-12 row">
                <div className="col-md-6 renew_membership_label">
                  <span>Membership No.</span>
                </div>
                <div className="col-md-6 renew_membership_data">
                  <span>{RenewMembershipData.memberID}</span>
                </div>
              </div>
              <div className="col-md-12 row">
                <div className="col-md-6 renew_membership_label">
                  <span>Company Name</span>
                </div>
                <div className="col-md-6 renew_membership_data">
                  <span>{RenewMembershipData.company_name}</span>
                </div>
              </div>
              <div className="col-md-12 row">
                <div className="col-md-6 renew_membership_label">
                  <span>Renewal Terms</span>
                </div>
                <div className="col-md-6 renew_membership_data">
                  <span>
                    {RenewMembershipData.min_term} -{" "}
                    {RenewMembershipData.max_term}
                  </span>
                </div>
              </div>
              <div className="col-md-12 row">
                <div className="col-md-6 renew_membership_label">
                  <span>Subscription Type</span>
                </div>
                <div className="col-md-6 renew_membership_data">
                  <span>Annual Subscription</span>
                </div>
              </div>
            </div>
          ) : (
            <Typography>Loading...</Typography>
          )}

          {/* Modal Content */}
          <Typography
            sx={{
              fontSize: "30px",
              fontWeight: "bold",
              color: "#b24743",
              marginBottom: "10px",
              marginTop: "25px",
            }}
          >
            Payment Details
          </Typography>
          <div className="renew_memebership_modal2">
            <div className="col-md-12 row">
              <div className="col-md-6 renew_membership_label">
                <span>Subtotal</span>
              </div>
              <div className="col-md-6 renew_membership_data2">
                <span>RM {RenewMembershipData.amount}</span>
              </div>
            </div>
            <div className="col-md-12 row">
              <div className="col-md-6 renew_membership_label">
                <span>Total</span>
              </div>
              <div className="col-md-6 renew_membership_data2">
                <span>RM {RenewMembershipData.amount}</span>
              </div>
            </div>
          </div>
          <Box textAlign="center">
            <Button
              sx={{
                borderRadius: "20px",
                mt: 4,
                mb: 4,
                width: "100%",
                height: "48px",
                backgroundColor: "#d33333",
                textTransform: "none",
              }}
              variant="contained"
              type="submit"
            >
              <Typography variant="h6">Generate Invoice</Typography>
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal Edit Profile */}
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%", // Adjust width for responsiveness
            maxWidth: 1000, // Maximum width
            maxHeight: "90vh", // Maximum height for smaller screens
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            overflowY: "auto", // Enable vertical scrolling if content overflows
          }}
        >
          <div
            onClick={handleCloseModal}
            className="col-md-12 close-modal-icon"
          >
            <CloseIcon className="cmi" />
          </div>
          <div className="personal-details-title">
            <span>Personal Details</span>
          </div>

          {/* Form fields populated with user data */}
          <form onSubmit={handleUpdateUserProfile}>
            <input name="userId" value={userData.userId} hidden />
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {/* Profile Image */}
                <Grid size={{ xs: 12, md: 12 }}>
                  <label className="ep-label form-label">Profile Image</label>
                  <div style={{ textAlign: "center" }}>
                    {!image && (
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        {/* Hidden file input */}
                        <input
                          id="file-input"
                          type="file"
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />
                        <IconButton onClick={handleUploadClick}>
                          {userData.profile_image &&
                          userData.profile_image.trim() !== "" ? (
                            <img
                              src={userData.profile_image}
                              className="ep-profile-image"
                              alt="Profile"
                            />
                          ) : (
                            <AccountCircleIcon
                              sx={{ fontSize: 200, color: "gray" }} // Adjust size and color
                            />
                          )}
                        </IconButton>
                        <UploadIcon
                          className="profile-edit-icon"
                          sx={{
                            position: "absolute",
                            bottom: 20,
                            right: 20,
                            fontSize: "30px",
                            border: "1px solid white",
                            borderRadius: "50%",
                            padding: "2px",
                            backgroundColor: "#d33333",
                            color: "white",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    )}

                    {image && (
                      <div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "30px",
                            margin: "20px auto",
                            maxWidth: "800px",
                          }}
                        >
                          {/* Cropped Preview */}
                          {croppedImage && (
                            <div>
                              <div
                                style={{
                                  width: "200px",
                                  height: "200px",
                                  borderRadius: "50%",
                                  overflow: "hidden",
                                  border: "2px solid #ddd",
                                  margin: "10px auto",
                                }}
                              >
                                <img
                                  src={croppedImage}
                                  alt="Cropped Preview"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            </div>
                          )}

                          {/* <button
                            onClick={handleReupload}
                            style={{
                              position: "relative",
                              marginLeft: "10px",
                              marginTop: "10px",
                              padding: "8px 16px",
                              cursor: "pointer",
                              borderRadius: "4px",
                            }}
                          >
                            Cancel
                          </button> */}
                        </div>

                        {/* Cropper Area */}
                        <div
                          style={{
                            position: "relative",
                            width: "250px",
                            height: "250px",
                          }}
                        >
                          <Cropper
                            image={image}
                            crop={crop}
                            zoom={zoom}
                            aspect={1}
                            cropShape="round"
                            showGrid={false}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={onCropComplete}
                          />
                        </div>

                        {/* Buttons */}
                        <div>
                          {/* <button
                            type="button" // Prevents form submission
                            onClick={handleSave}
                            style={{ marginTop: "10px" }}
                          >
                            Save Cropped Image
                          </button> */}
                          <button
                            onClick={handleReupload}
                            style={{
                              position: "relative",
                              marginLeft: "10px",
                              marginTop: "10px",
                              backgroundColor: "#d33333",
                              color: "white",
                              border: "none",
                              padding: "8px 16px",
                              cursor: "pointer",
                              borderRadius: "4px",
                            }}
                          >
                            Reupload Image
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </Grid>
                {/* Salutation */}
                <Grid size={{ xs: 6, md: 3 }}>
                  <label className="ep-label form-label">Salutation</label>
                  <input
                    className="ep-input2 form-control"
                    name="salutation"
                    value={userData.salutation || ""}
                    // onChange={(event) =>
                    //   handleUserInputChange(event.target.value, "salutation")
                    // }
                    onChange={handleUserInputChange}
                  />
                </Grid>
                {/* Name */}
                <Grid size={{ xs: 6, md: 9 }}>
                  <label className="ep-label form-label">
                    Full Name (as per NRIC){required()}
                  </label>
                  <input
                    name="name"
                    className="ep-input2 form-control"
                    type="text"
                    placeholder="Name"
                    value={userData.name}
                    onChange={handleUserInputChange}
                    required
                  />
                </Grid>
                {/* NRIC */}
                <Grid size={{ xs: 6, md: 6 }}>
                  <label className="ep-label form-label">
                    NRIC{required()}
                  </label>
                  <input
                    name="nric"
                    className="ep-input2 form-control"
                    type="text"
                    placeholder="xxxxxx-xx-xxxx"
                    value={userData.nric}
                    onChange={handleUserInputChange}
                    required
                  />
                </Grid>
                {/* Email */}
                <Grid size={{ xs: 6, md: 6 }}>
                  <label className="ep-label form-label">
                    Email{required()}
                  </label>
                  <input
                    name="email"
                    className="ep-input2 form-control"
                    type="email"
                    placeholder="Email"
                    value={userData.email}
                    required
                  />
                </Grid>
                {/* Address */}
                <Grid size={{ xs: 12, md: 12 }}>
                  <label className="ep-label form-label">
                    Address{required()}
                  </label>
                  <input
                    name="address"
                    className="ep-input2 form-control"
                    type="text"
                    placeholder="Address"
                    value={userData.address}
                    onChange={handleUserInputChange}
                    required
                  />
                </Grid>
                {/* Phone Number */}
                <Grid size={{ xs: 6, md: 6 }}>
                  <label className="ep-label form-label">
                    Mobile No.{required()}
                  </label>
                  <input
                    name="phone_number"
                    className="ep-input2 form-control"
                    type="number"
                    placeholder="Phone Number"
                    value={userData.phone_number}
                    onChange={handleUserInputChange}
                    required
                  />
                </Grid>
                {/* Academic Qualification */}
                <Grid size={{ xs: 6, md: 6 }}>
                  <label className="ep-label form-label">
                    Academic Qualification
                  </label>
                  <select
                    className="ep-input2 form-select"
                    value={userData.academic_qualification}
                    onChange={handleUserInputChange}
                  >
                    <option value="0">None</option>
                    <option value="1">Certificate</option>
                    <option value="2">Diploma</option>
                    <option value="3">Advanced Diploma</option>
                    <option value="4">Bachelor</option>
                    <option value="5">Masters</option>
                    <option value="6">Doctoral</option>
                  </select>
                  {/* <input
                      name="academic_qualification"
                      className="ep-input2 form-control"
                      type="text"
                      placeholder="Academic Qualification"
                      value={userData.academic_qualification}
                      onChange={handleUserInputChange}
                    /> */}
                </Grid>
              </Grid>

              <div className="office-details-title">
                <span>Office Details</span>
              </div>

              <Grid container spacing={2}>
                {/* Office Email */}
                <Grid size={{ xs: 6, md: 6 }}>
                  <label className="ep-label form-label">
                    Alternate Email{required()}
                  </label>
                  <input
                    name="office_email"
                    className="ep-input2 form-control"
                    type="email"
                    placeholder="Office Email"
                    value={userData.alternate_email}
                    onChange={handleUserInputChange}
                    required
                  />
                </Grid>
                {/* Office Tel No */}
                <Grid size={{ xs: 6, md: 6 }}>
                  <label className="ep-label form-label">
                    Office Tel No.{required()}
                  </label>
                  <input
                    name="office_tel_no"
                    className="ep-input2 form-control"
                    type="text"
                    placeholder="Office Tel.No"
                    value={userData.office_tel_no}
                    onChange={handleUserInputChange}
                    required
                  />
                </Grid>
                {/* Designation */}
                <Grid size={{ xs: 6, md: 6 }}>
                  <label className="ep-label form-label">
                    Designation{required()}
                  </label>
                  <input
                    name="designation"
                    className="ep-input2 form-control"
                    type="text"
                    placeholder="Designation"
                    value={userData.designation}
                    onChange={handleUserInputChange}
                    required
                  />
                </Grid>
                {/* Nature Of Work/Department */}
                <Grid size={{ xs: 6, md: 6 }}>
                  <label className="ep-label form-label">
                    Nature of Work / Department
                  </label>
                  <input
                    name="nature_of_work"
                    className="ep-input2 form-control"
                    type="text"
                    placeholder="Nature of Work"
                    value={userData.nature_of_work}
                    onChange={handleUserInputChange}
                  />
                </Grid>
                {/* Years with Company */}
                <Grid size={{ xs: 6, md: 6 }}>
                  <label className="ep-label form-label">
                    Years with Company
                  </label>
                  <input
                    name="years_with_company"
                    className="ep-input2 form-control"
                    type="number"
                    min={1}
                    placeholder="Years with Company"
                    value={userData.years_with_company}
                    onChange={handleUserInputChange}
                  />
                </Grid>
              </Grid>

              <Box textAlign="center">
                <Button
                  sx={{
                    borderRadius: "20px",
                    mt: 4,
                    mb: 4,
                    width: "100%",
                    height: "48px",
                    backgroundColor: "#d33333",
                    textTransform: "none",
                  }}
                  variant="contained"
                  type="submit"
                >
                  <Typography variant="h6">Update Profile</Typography>
                </Button>
              </Box>

              <Grid
                size={{ xs: 12, md: 12 }}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <InfoIcon fontSize="small" sx={{ marginRight: "5px" }} />
                <label>
                  Last updated on{" "}
                  {dayjs(userData.datetime_updated).format(
                    "DD-MM-YYYY HH:mm:ss"
                  )}
                </label>
              </Grid>
            </Box>
          </form>
        </Box>
      </Modal>
    </React.Fragment>
  );
  // }
};

export default EditProfile;
